import CreateThiSensorModal from "./create-thi-sensor-modal.vue";

export default CreateThiSensorModal;



// WEBPACK FOOTER //
// ./src/components/_modals/create-thi-sensor/index.js